<template>
  <div class='LinkSidebar'
  v-if="Template03.indexOf(data.text) >= 0 || Theme.name != 'Modelo 03'"
  >
    <div
    :style="{ borderLeft: `7px solid ${
      !$route.name
      ? colorBlackIcon || $route.matched[this.$route.matched.length - 2].path === data.path ? '#648EEA' : Prefes.navepainel.corBackground 
      : colorBlackIcon || $route.fullPath === data.path ? '#648EEA' : Prefes.navepainel.corBackground}`
    }"
    class="cont-link"
    @click="run"
    @mouseenter="colorBlackIcon=true"
    @mouseleave="colorBlackIcon=false"
    >
      <component :is="data.icon" :color="colorIcon"/>
      <div class="space"></div>
      {{ text }}
    </div>
    <div v-if="showSubLink">
      <sub-link
      v-for="(link, k) in data.child"
      :key="k"
      :data="link"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProdIcon from './Icons/ProdIcon'
import ClientIcon from './Icons/ClientIcon'
import ListIcon01 from '../Theme01/Icons/ListIcon01'
import StoreIcon01 from '../Theme01/Icons/StoreIcon01'
import GiftIcon from '../EnbPainel/Icons/GiftIcon'
import UserIcon from '../EnbPainel/Icons/UserIcon'
import ConfigIcon from '../EnbPainel/Icons/ConfigIcon'
import SubLink from '@/components/EnbPainel/SubLink'
import PayIcon from '../EnbPainel/Icons/PayIcon'
import DeliveryIcon from './Icons/DeliveryIcon'
import MarketingIcon from './Icons/MarketingIcon'
import SiteIcon from './Icons/SiteIcon'
import DashIcon from './Icons/DashIcon'
import UserIcon01 from '@/components/Theme01/Icons/UserIcon01'
export default {
  name: 'LinkSidebar',
  components: { SubLink, ProdIcon, ClientIcon, ListIcon01, StoreIcon01, GiftIcon, UserIcon, ConfigIcon, PayIcon, DeliveryIcon, MarketingIcon, SiteIcon, DashIcon, UserIcon01 },
  computed: {
    ...mapGetters(['Template03', 'Theme', 'Empresa', 'Prefes']),
    // Conversão de descrição do Modelo 03
    text () {
      if(this.data.text === 'Produtos' && this.Theme.name === 'Modelo 03') {
        return 'Imóveis'
      }
      if(this.data.text === 'Loja' && this.Theme.name === 'Modelo 03') {
        return 'Site'
      }
      return this.data.text
    },
    colorIcon () {
      if(this.colorBlackIcon) {
        return '#000000'
      } else {
        return this.Prefes.navepainel.corFont
      }
    }
  },
  data () {
    return {
      showSubLink: false,
      colorBlackIcon: false
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({ text: 'Modulo', path: '', child: [] })
    }
  },
  methods: {
    ...mapActions(['PushMsg']),
    run () {
      if(!this.Empresa.frenteloja && this.data.path === '/') {
        this.PushMsg({ msg: 'Frente de loja desativada. Ative em Marketing', color: 'orange' })
        return
      }
      if(typeof this.data.child === 'undefined' && typeof this.data.path !== 'undefined') {
        if(this.data.text === 'Loja' && this.Theme.name === 'Modelo 03') {
          this.$router.push('/site')
          return
        }
        this.$router.push(this.data.path)
      }
      if(!this.showSubLink) {
        this.showSubLink = true
      } else {
        this.showSubLink = false
      }
    }
  },
  created () {
    //alert(this.$route.fullPath)
  }
}
</script>

<style scoped>
.LinkSidebar {
  cursor: pointer;
}

.cont-link {
  display: flex;
  padding: 3%;
  justify-content: left;
  align-items: center;
  border-left: 7px solid #FFFFFF;
}

.cont-link:hover {
  background-color: #EEEEEE;
  border-left: 7px solid #648EEA;
  color: #000000;
}

.space {
  width: 2%;
}

.disabled {
  opacity: 0.50;
}
</style>
